import { Blocked, ComingSoon, Favorites, NewPasswordRequired, Penalties, SignIn, SoldOut, Splash, Wallet } from '../pages'
import { signInLandingSelected } from '../helpers/app'
import { configurationRoutes, configurationUrls } from './configuration'
import { newReservationRoutes, newReservationUrls } from './new-reservation'
import { recoverPasswordRoutes, recoverPasswordUrls } from './recover-password'
import { reservationsRoutes, reservationsUrls } from './reservations'
import { signUpRoutes, signUpUrls } from './sign-up'
import { verificationRoutes, verificationUrls } from './verification'

export const urls = {
  ...newReservationUrls,
  ...reservationsUrls,  
  ...signUpUrls,
  ...recoverPasswordUrls,
  ...verificationUrls,
  favorites: '/favorites',
  penalties: '/penalties',
  wallet: '/wallet',
  signIn: '/sign-in',
  splash: '/',
  blocked: '/blocked',
  newPasswordRequired: '/new-password-required',
  comingSoon: '/comming-soon/:locale',
  soldOut: '/sold-out/:locale',
  config: '/configuration',
  configuration: configurationUrls
}

export const landingPanelUrls = [
  urls.signIn,
  ...Object.values(signUpUrls),
  ...Object.values(recoverPasswordUrls),
  ...Object.values(verificationUrls),
  urls.newPasswordRequired
]

const authRoutes = signInLandingSelected
  ? [ { content: SignIn, url: landingPanelUrls, isAuthenticated: false } ]
  : [
    ...signUpRoutes,
    ...recoverPasswordRoutes,
    ...verificationRoutes,
    { content: SignIn, url: urls.signIn, isAuthenticated: false },
    { content: NewPasswordRequired, url: urls.newPasswordRequired, isAuthenticated: false }
  ]

export const routes = [
  ...newReservationRoutes,
  ...reservationsRoutes,
  ...configurationRoutes,
  ...authRoutes,
  { content: Favorites, url: urls.favorites, isAuthenticated: true },
  { content: Penalties, url: urls.penalties, isAuthenticated: true },
  { content: Wallet, url: urls.wallet, isAuthenticated: true },
  { content: Blocked, url: urls.blocked, isAuthenticated: false },
  { content: ComingSoon, url: urls.comingSoon, isAuthenticated: false },
  { content: SoldOut, url: urls.soldOut, isAuthenticated: false },
  { content: Splash, url: urls.splash, isAuthenticated: false },
]
